import React, { useState, useEffect } from "react";
import axios from "axios";
import config from "../../confiq/confiq";
import "./index.css";
import StarRating from "../../components/starRating";
import { ArrowRight, MapPin } from "@phosphor-icons/react";
import TestimonialsSlider from "../../components/TestimonialsSlider";
import ProjectsSlider from "../../components/ProjectsSlider";
import { useParams } from "react-router-dom";
import ServiceCard from "../../components/ServiceCard";

const PartnerList = () => {
  const [partnerList, setPartnerListData] = useState([]);
  const { slug } = useParams();
  useEffect(() => {
    axios
      .get(`${config.apiUrl}api/partner/partnerlist?search=${slug || null}`, {
        headers: config.headers,
      })
      .then((response) => {
        setPartnerListData(response?.data?.data?.data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, [slug]);
  console.log("partner list", partnerList);
  return (
    <div className="flex-grow partnerList px-28">
      {partnerList?.map((partner) => (
        <div key={partner?.id} className="partner-container">
          {/* Partner Header */}
          <div className="partner-section flex gap-8 ">
            <div className="w-1/3 partner-stats partner-card">
            <div className="partner-stats-header">
              <div className="flex items-center gap-4">
                {partner?.attributes?.partner_logo?.data?.attributes?.url && (
                  <img
                    src={partner?.attributes?.partner_logo?.data?.attributes?.url}
                    alt={partner?.attributes?.partner_name}
                    // className="w-16 h-16"
                     className="w-10 h-10 md:w-14 md:h-14 lg:w-16 lg:h-16"
                  />
                )}
                <h1 className="text-xl md:text-2xl lg:text-3xl font-bold">{partner?.attributes?.partner_name}</h1>
              </div>
              {partner?.attributes?.rating && (
                <div className="text-sm mt-0 md:mt-4 lg:mt-4">
                  <StarRating rating={partner?.attributes?.rating} />{" "}
                </div>
              )}
              </div>
              {partner?.attributes?.location && (
                <p className="flex items-center mr-2 mt-4">
                  {partner?.attributes?.location_icon?.data?.attributes?.url ? (
                    <img
                      src={partner?.attributes?.location_icon?.data?.attributes?.url}
                      alt={partner?.attributes?.partner_name}
                    />
                  ) : (
                    <MapPin size={20} />
                  )}
                  <span className="ml-2">{partner?.attributes?.location}</span>
                </p>
              )}

              <div className="flex items-center mr-1 mt-4">
                {partner?.attributes?.contact_button?.map((button, index) => (
                  <a href={button?.url} target="_blank" rel="noopener noreferrer" className="contact-button mr-2">
                    {button?.title}
                  </a>
                ))}
                <a
                  href={partner?.attributes?.website_url?.url || ""}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="ml-4 rounded-lg text-[#5D5FF3] hover:text-[#5D5FF3] font-medium text-base"
                >
                  {partner?.attributes?.website_url?.title}
                </a>
                {partner?.attributes?.website_url?.title && (
                  <ArrowRight className="ml-2 rounded-lg text-[#5D5FF3] font-medium cursor-pointer" size={24} />
                )}
              </div>
            </div>
            {/* About Us Section */}
            {/* <div className="w-full md:w-2/3 lg:w-2/3"> */}
            <div className="w-ful lg:w-2/3">
              <h2 className="mb-2 text-2xl font-bold">{partner?.attributes?.about_title}</h2>
              <div className="text-gray-600 space-y-2">
                <div
                  className="text-gray-600 space-y-2 font-medium"
                  dangerouslySetInnerHTML={{ __html: extractText(partner?.attributes?.about_description) }}
                />
              </div>
            </div>
          </div>

          {partner?.attributes?.service_project_title && partner?.attributes?.service_projects?.length > 0 && (
            <ServiceCard
              projects={partner?.attributes?.service_projects}
              title={partner?.attributes?.service_project_title}
            />
          )}
          {/* SaaS Partners */}
          {partner?.attributes?.saas_partner_title && partner?.attributes?.saas_partner_logo?.length > 0 && (
            <div className="saas-network">
              <p className="head-text">{partner?.attributes?.saas_partner_title}</p>
              <div className="padding-medium">
                <div className="w-layout-hflex">
                  <div className="line-logo bg-blue"></div>
                  <div className="line-logo bg-yellow"></div>
                  <div className="line-logo"></div>
                </div>
              </div>
              <div className="Partners-icons">
                {partner?.attributes?.saas_partner_logo?.map((logo) => (
                  <img
                    key={logo?.id}
                    src={logo?.logoImage?.data?.attributes?.url}
                    alt={logo?.logoImage?.data?.attributes?.alternativeText || "Partners Logo"}
                    className="Partners-img w-full h-auto object-contain"
                  />
                ))}
              </div>
              <div className="padding-medium">
                <div className="w-layout-hflex">
                  <div className="line-logo"></div>
                  <div className="line-logo bg-yellow"></div>
                  <div className="line-logo bg-blue"></div>
                </div>
              </div>
            </div>
          )}
          {/* Challenges We Solve */}
          {(partner?.attributes?.saas_challenges?.title || partner?.attributes?.list_items?.length > 0) && (
            <div
              className={`flex gap-10 mt-6 ${
                partner?.attributes?.saas_challenges?.description && partner?.attributes?.list_items?.length > 0
                  ? "flex-row"
                  : "justify-center"
              } partner-challenges-section`}
            >
              {/* SaaS Challenges */}
              {partner?.attributes?.saas_challenges?.title &&
                partner?.attributes?.saas_challenges?.description?.length > 0 && (
                  <div className={`${partner?.attributes?.list_items?.length > 0 ? "w-full md:w-2/3" : "w-full"}`}>
                    <h2 className="mb-2 text-2xl font-bold">{partner?.attributes?.saas_challenges?.title}</h2>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: extractText(partner?.attributes?.saas_challenges?.description),
                      }}
                    />
                  </div>
                )}

              {partner?.attributes?.list_items?.length > 0 && (
                <div className="partner-stats item-card w-1/3">
                  {partner?.attributes?.list_items?.map((item) => (
                    <div key={item?.id} className="mb-4">
                      <h3 className="text-base text-[#5D5FF3] mb-1">{item?.list_item_title}</h3>
                      <div className="text-sm">
                        {item?.list_item_category?.map((category) => (
                          <div className="mb-2 font-medium" key={category?.id}>
                            {category?.list_item_category}
                          </div>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}
          {/* video link */}
          {partner?.attributes?.video_link_title && partner.attributes?.video_link?.data?.attributes?.url && (
            <div className="video-section">
              <p className="head-text mb-2">{partner?.attributes?.video_link_title}</p>
              <video controls className="w-full mt-2">
                <source src={partner?.attributes?.video_link?.data?.attributes?.url} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          )}

          {/* Accreditations */}
          {partner.attributes?.accreditations_title && partner?.attributes?.accreditations?.length > 0 && (
            <div className="Partners-network">
              <h2 className="head-text">{partner.attributes?.accreditations_title}</h2>
              <div className="flex flex-row mt-4">
                {partner.attributes?.accreditations.map((acc) => (
                  <div key={acc.id} className="flex flex-col items-center mr-8 ml-8">
                    <div className="h-20 w-20 p-2 rounded-full flex items-center justify-center">
                      {/* bg-[#f0eeee] */}
                      <img
                        src={acc?.logo?.data?.attributes?.url}
                        alt={acc?.logo?.data?.attributes?.alternativeText}
                        className="object-cover"
                      />
                    </div>

                    <p className="mt-4 font-inter font-semibold text-[16px] leading-[19.36px] text-gray-600 text-center">
                      {acc?.name}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          )}
          {partner?.attributes?.partner_testmonial_title && partner.attributes?.partner_testmonial?.length > 0 && (
            <TestimonialsSlider
              testimonials={partner?.attributes?.partner_testmonial}
              title={partner.attributes?.partner_testmonial_title}
            />
          )}

          {partner?.attributes?.project_title && partner?.attributes?.project_details?.length > 0 && (
            <ProjectsSlider
              projects={partner?.attributes?.project_details}
              title={partner?.attributes?.project_title}
            />
          )}
        </div>
      ))}
    </div>
  );
};

const extractText = (content) => {
  return content
    ?.map((block) => {
      if (block.type === "paragraph") return `<p>${block.children.map(formatText).join(" ")}</p>`;
      if (block.type === "list")
        return `<${block.format === "ordered" ? "ol" : "ul"} style="padding-left: 20px; list-style-type: ${
          block.format === "ordered" ? "decimal" : "disc"
        };">${block.children
          .map((item) => `<li className="mb-2">${item.children.map(formatText).join("")}</li>`)
          .join("")}</${block.format === "ordered" ? "ol" : "ul"}>`;
      if (block.type === "heading")
        return `<h${Math.min(6, Math.max(3, block.level || 3))}>${block.children.map(formatText).join("")}</h${Math.min(
          6,
          Math.max(3, block.level || 3)
        )}>`;
      if (block.type === "quote") return `<blockquote>${block.children.map(formatText).join("")}</blockquote>`;
      if (block.type === "image")
        return `<img src="${block.image.url}" alt="${
          block.image.alternativeText || "Image"
        }" style="max-width:100%; height:auto;" />`;
      return "";
    })
    .join("\n");
};

const formatText = (child) => {
  let text = child.text || "";
  if (child.bold) text = `<b>${text}</b>`;
  if (child.italic) text = `<i>${text}</i>`;
  if (child.underline) text = `<u>${text}</u>`;
  if (child.strikethrough) text = `<s>${text}</s>`;
  if (child.code) text = `<code>${text}</code>`;
  if (child.type === "link")
    text = `<a href="${child.url}" target="_blank">${child.children.map(formatText).join("")}</a>`;
  return text;
};

export default PartnerList;
